export default [
  {
    path: '/kiosk',
    name: 'kiosk',
    component: () => import('@/views/kiosk/Kiosk'),
    meta: {
      protected: true,
      pageTitle: 'Kiosk',
    },
  },
  {
    path: '/kiosk-print',
    name: 'kiosk-print',
    component: () => import('@/views/kiosk/KioskPrint'),
    meta: {
      protected: true,
      pageTitle: 'Kiosk Print',
    },
  },
]
